function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'watermelon-red': 'rgb(255, 125, 102)','blue-glow-in-the-dark': 'rgb(29, 204, 255)','ash': 'rgb(215, 215, 215)','azalea': 'rgb(248, 149, 255)','blue': 'rgb(8, 179, 249)','black': 'rgb(0, 0, 0)','bone': 'rgb(231, 227, 208)','brown-savana': 'rgb(158, 140, 137)','carbon-grey': 'rgb(151, 151, 151)','cardinal': 'rgb(242, 14, 14)','carolina-blue': 'rgb(146, 180, 236)','charcoal': 'rgb(127, 123, 123)','daisy': 'rgb(244, 195, 74)','dark-blue': 'rgb(7, 50, 126)','dark-chocolate': 'rgb(78, 52, 52)','dark-heather': 'rgb(69, 69, 69)','forest-green': 'rgb(24, 94, 6)','gold': 'rgb(247, 157, 7)','green': 'rgb(64, 194, 0)','gray': 'rgb(138, 138, 138)','heliconia': 'rgb(250, 24, 154)','ice-grey': 'rgb(218, 213, 213)','latte': 'rgb(215, 191, 191)','irish-green': 'rgb(49, 178, 64)','light-blue': 'rgb(148, 197, 238)','khaki': 'rgb(167, 149, 149)','light-pink': 'rgb(248, 208, 248)','lime': 'rgb(99, 247, 11)','maroon': 'rgb(121, 18, 18)','military-green': 'rgb(91, 126, 91)','natural': 'rgb(212, 193, 170)','navy': 'rgb(9, 59, 108)','oatmeal-heather': 'rgb(218, 200, 200)','orange': 'rgb(252, 78, 12)','pink': 'rgb(255, 97, 237)','platinum': 'rgb(214, 212, 212)','purple': 'rgb(134, 3, 215)','purple-glow-in-the-dark': 'rgb(134, 3, 215)','red': 'rgb(255, 12, 12)','royal': 'rgb(5, 68, 239)','sand': 'rgb(227, 220, 213)','sapphire': 'rgb(43, 101, 243)','sport-grey': 'rgb(185, 183, 183)','sky': 'rgb(113, 188, 245)','team-gold': 'rgb(218, 177, 7)','tropical-blue': 'rgb(20, 172, 180)','turf-green': 'rgb(33, 147, 11)','white': 'rgb(255, 255, 255)','yellow': 'rgb(231, 250, 9)','yellow-haze': 'rgb(238, 201, 142)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
